import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { StatusStatusPurchaseTypes } from 'shared/constants'
import { Paper } from 'shared/ui/paper'
import { StatusBought } from 'shared/ui/status-bought'

import s from './styles.module.scss'

interface Props {
  isExcursion?: boolean
  status: StatusStatusPurchaseTypes
}

export const GuideStatus: FC<Props> = ({ status, isExcursion }) => {
  const { t } = useTranslation()

  if (!status) return null

  return (
    <Paper padding={[13, 16]}>
      <div className={s.container}>
        <span className={clsx(s.left, 'medium-14')}>{t('status_order')}</span>

        <StatusBought
          status={status}
          isExcursion={isExcursion}
        />
      </div>
    </Paper>
  )
}
